import React from 'react'

const AuthFooter = () => {
  return (
    <>
      {/* Footer */}
      <div className="footer-copyright  bg-transparent">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p style={{color: "white"}}>Copyright © {new Date().getFullYear()}. All Rights Reserved MahiGo</p>
            </div>
          </div>
        </div>
      </div>
      {/* /Footer */}
    </>

  )
}

export default AuthFooter